import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';

export default class NodeMirror extends Node
{
	constructor(pParent)
	{
		super(pParent);
		
		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addInput(PARAM_TYPE.BOOLEAN, 'flip_x', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'flip_y', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'flip_z', false);

		this.addInput(PARAM_TYPE.BOOLEAN, 'mirror_x', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'mirror_y', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'mirror_z', false);

		this.addInput(PARAM_TYPE.BOOLEAN, 'make_new_copy', false);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');	
	}
	
	getType()
	{
		return 'mirror_v2';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{		
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;
		
		let vecLocalScalingMults = BABYLON.Vector3.Zero();
		let vecWorldScaleValues = BABYLON.Vector3.Zero();
		vecWorldScaleValues.x = inputValues['flip_x'] ? -1 : 1;
		vecWorldScaleValues.y = inputValues['flip_y'] ? -1 : 1;
		vecWorldScaleValues.z = inputValues['flip_z'] ? -1 : 1;

		let vecWorldPositionFlipValues = BABYLON.Vector3.Zero();
		vecWorldPositionFlipValues.x = inputValues['mirror_x'] ? -1 : 1;
		vecWorldPositionFlipValues.y = inputValues['mirror_y'] ? -1 : 1;
		vecWorldPositionFlipValues.z = inputValues['mirror_z'] ? -1 : 1;

		let vecWorldNormalScales = new BABYLON.Vector3(1,1,1);
		let vecLocalNormalScalingMults = BABYLON.Vector3.Zero();
		let vecFinalScaleMults = BABYLON.Vector3.Zero();

		let vecPrevAbsPivotPoint = BABYLON.Vector3.Zero();
		let vecNewAbsPivotPoint = BABYLON.Vector3.Zero();

		let meshesBbox = Utils3D.getObjectsBBoxWithChildren(pGeoList);
		let meshesCenter = meshesBbox.maximumWorld.add(meshesBbox.minimumWorld).scale(0.5);

		let invertedWorldMat = new BABYLON.Matrix();

		let pFinalMeshes = [];
		let iCounter = 0;
		for(let pSrcMesh of pGeoList)
		{
			let pFinalMesh = pSrcMesh;
			if(inputValues['make_new_copy'])
			{
				pFinalMesh = Utils3D.cloneMesh(pSrcMesh, this.getGeneratedMeshName() + "_" + iCounter);
				this.onMeshCreated(pFinalMesh);
				iCounter++;
			}

			let currCenter = meshesBbox.maximumWorld.add(meshesBbox.minimumWorld).scale(0.5);

			let worldMatrix = pFinalMesh.getWorldMatrix();
			worldMatrix.invertToRef(invertedWorldMat);

			BABYLON.Vector3.TransformNormalToRef(vecWorldScaleValues, invertedWorldMat, vecLocalScalingMults);
			BABYLON.Vector3.TransformNormalToRef(vecWorldNormalScales, invertedWorldMat, vecLocalNormalScalingMults);

			if(Math.abs(vecLocalScalingMults.x) > 1e-7)
				vecLocalScalingMults.x /= Math.abs(vecLocalScalingMults.x);
			if(Math.abs(vecLocalScalingMults.y) > 1e-7)
				vecLocalScalingMults.y /= Math.abs(vecLocalScalingMults.y);
			if(Math.abs(vecLocalScalingMults.z) > 1e-7)
				vecLocalScalingMults.z /= Math.abs(vecLocalScalingMults.z);

			if(Math.abs(vecLocalNormalScalingMults.x) > 1e-7)
				vecLocalNormalScalingMults.x /= Math.abs(vecLocalNormalScalingMults.x);
			if(Math.abs(vecLocalNormalScalingMults.y) > 1e-7)
				vecLocalNormalScalingMults.y /= Math.abs(vecLocalNormalScalingMults.y);
			if(Math.abs(vecLocalNormalScalingMults.z) > 1e-7)
				vecLocalNormalScalingMults.z /= Math.abs(vecLocalNormalScalingMults.z);

			vecLocalScalingMults.multiplyToRef(vecLocalNormalScalingMults, vecFinalScaleMults);	

			pFinalMesh.scaling.x *= vecFinalScaleMults.x;
			pFinalMesh.scaling.y *= vecFinalScaleMults.y;
			pFinalMesh.scaling.z *= vecFinalScaleMults.z;
			pFinalMesh.computeWorldMatrix(true);

			let origOffset = currCenter.subtract(meshesCenter);

			let newOffset = origOffset.multiply(vecWorldScaleValues).multiply(vecWorldPositionFlipValues);
			let vecOffsetDiff = newOffset.subtract(origOffset);
			pFinalMesh.position = pFinalMesh.position.add(vecOffsetDiff);

			pFinalMesh.computeWorldMatrix(true);
			let currCenter2 = meshesBbox.maximumWorld.add(meshesBbox.minimumWorld).scale(0.5);
			if(inputValues['mirror_x'])
				pFinalMesh.position.x += -meshesCenter.x - currCenter2.x;
			if(inputValues['mirror_y'])
				pFinalMesh.position.y += -meshesCenter.y - currCenter2.y;
			if(inputValues['mirror_z'])
				pFinalMesh.position.z += -meshesCenter.z - currCenter2.z;

			// Mirror the pivot point, as well, if we have one:
			const bIsUsingPivot = pFinalMesh.isUsingPivotMatrix();
			if(bIsUsingPivot)
			{
				pFinalMesh.getAbsolutePivotPointToRef(vecPrevAbsPivotPoint);
				vecPrevAbsPivotPoint.multiplyToRef(vecWorldPositionFlipValues, vecNewAbsPivotPoint);
				Utils3D.setWorldPivot(pFinalMesh, vecNewAbsPivotPoint);
			}

			pFinalMeshes.push(pFinalMesh);
		}

		return pFinalMeshes;
	}
}